var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "27",
      "height": "27",
      "viewBox": "0 1 27 27"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFE86C",
      "d": "M24.907 1.156H1.958C.91 1.156.06 2.006.06 3.055v13.778L0 27.233l5.985-5.943h18.922a1.9 1.9 0 0 0 1.9-1.898V3.055a1.9 1.9 0 0 0-1.9-1.9"
    }
  }), _c('path', {
    attrs: {
      "fill": "#005149",
      "d": "m14.25 14.345.3-10.422h-2.294l.299 10.422zm-.847 1.229c-.794 0-1.37.602-1.37 1.434 0 .83.576 1.433 1.37 1.433s1.37-.604 1.37-1.433c0-.844-.563-1.434-1.37-1.434"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }